// extracted by mini-css-extract-plugin
module.exports = {"moduleRoot":"Text_moduleRoot__jPRtE","center":"Text_center__2JqeG","header-2":"Text_header-2__38ZQU"};